import { HttpErrorResponse } from '@endurancewarranty/lib';
import { CustomValidationError } from '@lib/errors/CustomValidationError';

export function isExpectedGatewayError(error: unknown): boolean {
  if (error instanceof CustomValidationError) {
    return true;
  }

  if (!HttpErrorResponse.isHttpErrorResponse(error)) {
    return false;
  }

  const { statusCode } = error.getHttpErrorMetadata();
  return statusCode >= 400 && statusCode < 500;
}
